import React from "react";
import { CssBaseline, Container, makeStyles } from "@material-ui/core";
import styles from "src/layout/styles.jsx";
const useStyles = makeStyles(styles);

const Layout = ({ children, topbarChildren, sidebarChildren }) => {
  const classes = useStyles();
  const handleTopbarChildren = () => {
    return topbarChildren;
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={classes.content}>
        {handleTopbarChildren()}
        <Container className={classes.container}>{children}</Container>
      </main>
    </div>
  );
};
export default Layout;
export { Layout };
